import { Component, OnInit, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegionDataService } from '../shared/region-data.service';
import { OeAppService } from '../shared/oe-app.service';
import { LegalLinksDto, SocialMediaLinksDto } from '../shared/types/region-data-dto';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'lp2-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  isSocialDisplayed = true;
  isToolsDisplayed = true;
  isMobile: boolean;
  currentYear: number = new Date().getFullYear();
  copyrightTranslationParams = { copyrightYear: this.currentYear };
  termsAndConditionsUrl: SafeResourceUrl;
  serviceTermsUrl: SafeResourceUrl;
  privacyUrl: SafeResourceUrl;
  socialMediaLinks: SocialMediaLinksDto;

  constructor(
    private readonly element: ElementRef,
    private oeAppService: OeAppService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private regionService: RegionDataService
  ) { }

  ngOnInit() {
    this.regionService.links$.subscribe((data) => {
      if(data) {
        this.socialMediaLinks = data.socialMediaLinks;

        this.termsAndConditionsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.legalLinks.termsAndConditionsLink);
        this.serviceTermsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.legalLinks.serviceTermsLink);
        this.privacyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.legalLinks.privacyLink);
      }
    });

    this.isMobile = this.oeAppService.isMobileDevice();

    this.isToolsDisplayed = this.element.nativeElement.getAttribute('display-tools') !== 'false';

    this.isSocialDisplayed = this.element.nativeElement.getAttribute('display-social') !== 'false';
  }

  open(content, event) {
    if (!this.isMobile) {
      event.preventDefault();
      this.modalService.open(content, { windowClass: 'legal-modal' });
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/footer/footer.component.ts